export default {
  widthPC: 1040,
  cookieName: '_ac_user_token',
}
